var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoneiumSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 32,
    viewBox: "0 0 42 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 32,
    rx: 6,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3326 21.624C21.3742 21.8543 20.3729 21.8349 19.4241 21.5676C18.4753 21.3004 17.6108 20.7943 16.913 20.0976C15.9892 19.2144 15.3954 18.0412 15.2305 16.7733C15.0656 15.5053 15.3395 14.2191 16.0067 13.1287C16.4446 12.4178 16.9724 11.7665 17.5769 11.1909C19.4947 9.27852 23.0162 5.7987 23.0162 5.7987C20.398 5.27853 17.6802 5.78664 15.4263 7.2177C13.1723 8.64875 11.5551 10.893 10.9098 13.4852C10.2637 16.0771 10.6383 18.8184 11.9558 21.1416C13.2734 23.4649 15.4331 25.1921 17.988 25.9658L22.3326 21.624Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6578 10.379C20.6161 10.1483 21.6175 10.1675 22.5663 10.4347C23.515 10.702 24.3794 11.2083 25.0768 11.9054C26.9773 13.808 27.3485 16.6315 25.9762 18.8639C25.5375 19.5752 25.0098 20.2276 24.406 20.8052C22.4877 22.7147 18.9662 26.1968 18.9662 26.1968C21.5867 26.7221 24.3087 26.2168 26.5666 24.7858C28.8245 23.3548 30.4447 21.1081 31.0904 18.5126C31.7371 15.9174 31.3605 13.1725 30.0388 10.8478C28.7171 8.523 26.5517 6.79679 23.9921 6.02734L19.6578 10.379Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoneiumSymbol);
export default __webpack_public_path__ + "static/media/SoneiumSymbol.caca7e27caf1c529abb2e1173d1a01de.svg";
export { ForwardRef as ReactComponent };